import React from 'react'

function IconText({icon, title, classname, imgSrc}) {
  return (
    <div className={`mod-icon-text ${classname ? classname : ''}`}>
        {imgSrc ? (
            <img src={imgSrc} alt={title || 'icon'} className="mod-icon-text__icon" style={{width: '30px', height: '30px', objectFit: 'contain'}} />
        ) : (
            <span className={`mod-icon-text__icon icon icon-${icon}`}></span>
        )}
        <label className='mod-icon-text__label' dangerouslySetInnerHTML={{__html: title}}></label>
    </div>
  )
}

export default IconText